import { gql } from "@apollo/client";
import { client } from "api";

interface QueryParams {
  params: {
    documentId?: number;
    identityFileId?: number;
    minorAuthDocumentId?: number;
    vulnerabilityDocumentId?: number;
  };
}

interface QueryResult {
  getParticipantMergedFileBase64: string | null;
}

export const getParticipantMergedFileBase64 = async (
  params: QueryParams["params"],
): Promise<string | null> => {
  const response = await client.query<QueryResult, QueryParams>({
    query: gql`
      query GetParticipantMergedFileBase64(
        $params: GetParticipantMergedFileParams!
      ) {
        getParticipantMergedFileBase64(params: $params)
      }
    `,
    variables: { params },
    fetchPolicy: "no-cache",
  });
  return response.data?.getParticipantMergedFileBase64 ?? null;
};
